import styled, { css } from 'styled-components'
import { colors, fontScope, radius } from '../tokens'

export type BandState = 'sem' | 'ok' | 'quase' | 'esgotado'

const STATE_TEXT: Record<BandState, string> = {
  sem: colors.ink500,
  ok: colors.positive,
  quase: colors.warningText,
  esgotado: colors.dangerText,
}

export const Band = styled.section`
  ${fontScope}
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
  padding: 20px 24px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.card};
  background: ${colors.white};

  @media (max-width: 767px) {
    padding: 16px;
  }
`

export const Label = styled.span`
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.66px;
  text-transform: uppercase;
  color: ${colors.ink400};
`

export const Headline = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`

export const Percent = styled.span<{ $state: BandState }>`
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  letter-spacing: -0.6px;
  color: ${({ $state }) => STATE_TEXT[$state]};
`

export const None = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.ink500};
`

const badgeTone = {
  quase: css`
    background: ${colors.warningBg};
    color: ${colors.warningText};
  `,
  esgotado: css`
    background: ${colors.dangerBg};
    color: ${colors.dangerText};
  `,
}

export const Badge = styled.span<{ $state: 'quase' | 'esgotado' }>`
  padding: 2px 10px;
  border-radius: ${radius.pill};
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  ${({ $state }) => badgeTone[$state]}
`

export const Line = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 4px 12px;
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
  color: ${colors.ink600};
`

export const Counters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const Counter = styled.span<{ $state: 'quase' | 'esgotado' }>`
  padding: 4px 12px;
  border-radius: ${radius.pill};
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  ${({ $state }) => badgeTone[$state]}

  b {
    font-weight: 800;
  }
`
